import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

export default function SubscriptionUpdateMode()
{
    const [open, setOpen] = React.useState(true);

    const handleClose = (event) => {
        setOpen(true);
    };

    return (
        <div className="update-subscription">
            <Snackbar open={open} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity="warning"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    <AlertTitle><strong>Subscription Update</strong></AlertTitle>
                    You are currently updating your subscription.
                </Alert>
            </Snackbar>
        </div>
    );
}